import { render, staticRenderFns } from "./LocationTranslation.vue?vue&type=template&id=57589852&scoped=true&"
import script from "./LocationTranslation.vue?vue&type=script&lang=js&"
export * from "./LocationTranslation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57589852",
  null
  
)

export default component.exports